import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { motion, AnimatePresence } from "framer-motion";
import Logo from "../assets/img/logo/logo.svg";

import {
  Reveal,
  MagneticCTA,
} from "../motion";

import partner01 from "../images/partners/partner_01.jpg";
import partner02 from "../images/partners/partner_02.jpg";
import partner03 from "../images/partners/partner_03.jpg";
import partner04 from "../images/partners/partner_04.jpg";
import partner05 from "../images/partners/partner_05.jpg";
import partner06 from "../images/partners/partner_06.jpg";
import partner07 from "../images/partners/partner_07.jpg";
import partner08 from "../images/partners/partner_08.jpg";
import partner09 from "../images/partners/partner_09.jpg";
import partner10 from "../images/partners/partner_10.jpg";
import partner11 from "../images/partners/partner_11.jpg";
import partner12 from "../images/partners/partner_12.jpg";
import partner13 from "../images/partners/partner_13.jpg";
import partner14 from "../images/partners/partner_14.jpg";

import { useNavigate } from "react-router-dom";
import axios from "axios";
import { isEmpty } from "lodash";
import Select from "react-select";
import { ArrowUpRight, Building2, Globe2, ShieldCheck, GraduationCap, Landmark, Hospital, Truck, Award, Users, Briefcase } from "lucide-react";

// Events Partners (HMA Events clients also trusted by HMA Techs)
import evp01 from "../images/events partners/evp_01.jpg";
import evp02 from "../images/events partners/evp_02.jpg";
import evp03 from "../images/events partners/evp_03.jpg";
import evp04 from "../images/events partners/evp_04.jpg";
import evp05 from "../images/events partners/evp_05.jpg";
import evp06 from "../images/events partners/evp_06.jpg";
import evp07 from "../images/events partners/evp_07.jpg";
import evp08 from "../images/events partners/evp_08.jpg";
import evp09 from "../images/events partners/evp_09.jpg";
import evp10 from "../images/events partners/evp_10.jpg";
import evp11 from "../images/events partners/evp_11.jpg";
import evpCurtiss from "../images/events partners/curtiss.jpeg";
import evpS4ga from "../images/events partners/s4ga.jpeg";

const eventsPartnerLogos = [
  { src: evpCurtiss, category: "security" },
  { src: evpS4ga, category: "technology" },
  { src: evp01, category: "government" },
  { src: evp02, category: "healthcare" },
  { src: evp03, category: "education" },
  { src: evp04, category: "banking" },
  { src: evp05, category: "technology" },
  { src: evp06, category: "security" },
  { src: evp07, category: "logistics" },
  { src: evp08, category: "government" },
  { src: evp09, category: "education" },
  { src: evp10, category: "technology" },
  { src: evp11, category: "banking" },
];

const partnerLogos = [
  { src: partner01, category: "government" },
  { src: partner02, category: "government" },
  { src: partner03, category: "healthcare" },
  { src: partner04, category: "healthcare" },
  { src: partner05, category: "education" },
  { src: partner06, category: "education" },
  { src: partner07, category: "banking" },
  { src: partner08, category: "banking" },
  { src: partner09, category: "technology" },
  { src: partner10, category: "technology" },
  { src: partner11, category: "security" },
  { src: partner12, category: "security" },
  { src: partner13, category: "logistics" },
  { src: partner14, category: "logistics" },
];

const clientCategories = [
  { id: "government", icon: <Landmark size={22} />, label: "Government", labelFR: "Gouvernement", labelAR: "حكومي" },
  { id: "healthcare", icon: <Hospital size={22} />, label: "Healthcare", labelFR: "Santé", labelAR: "الصحة" },
  { id: "education", icon: <GraduationCap size={22} />, label: "Educational & Culture", labelFR: "Éducation & Culture", labelAR: "التعليم والثقافة" },
  { id: "banking", icon: <Building2 size={22} />, label: "Banking", labelFR: "Banque", labelAR: "بنوك" },
  { id: "technology", icon: <Globe2 size={22} />, label: "Information Technology", labelFR: "Technologies de l'information", labelAR: "تكنولوجيا المعلومات" },
  { id: "security", icon: <ShieldCheck size={22} />, label: "Security & Defense", labelFR: "Sécurité & Défense", labelAR: "الأمن والدفاع" },
  { id: "logistics", icon: <Truck size={22} />, label: "Logistics & Services", labelFR: "Logistique & Services", labelAR: "الخدمات اللوجستية" },
];

const Clients = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [eventsData, setEventsData] = useState([]);
  const [lang, setlang] = useState({ value: "EN", label: "EN" });
  const [menu, setmenu] = useState(false);
  const [activeCategory, setActiveCategory] = useState("all");

  const tr = (en, fr, ar) =>
    lang.value === "EN" ? en : lang.value === "FR" ? fr : ar;

  document.documentElement.dir = lang.value === "AR" && "rtl";

  useEffect(() => {
    const onScroll = () => {
      const h = document.querySelector("header.header");
      if (!h) return;
      h.classList.toggle("is-scrolled", window.scrollY > 24);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    if (menu) {
      document.body.style.overflow = "hidden";
      const onKey = (e) => e.key === "Escape" && setmenu(false);
      window.addEventListener("keydown", onKey);
      return () => {
        document.body.style.overflow = "";
        window.removeEventListener("keydown", onKey);
      };
    }
  }, [menu]);

  const navHash = (hash) => (e) => {
    e.preventDefault();
    setmenu(false);
    requestAnimationFrame(() => {
      setTimeout(() => {
        const el = document.getElementById(hash);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 80);
    });
  };

  const navRoute = (path) => (e) => {
    e.preventDefault();
    setmenu(false);
    setTimeout(() => navigate(path), 80);
  };

  useEffect(() => {
    if (
      localStorage.getItem("lang") &&
      JSON.parse(localStorage.getItem("lang"))
    ) {
      setlang(JSON.parse(localStorage.getItem("lang")));
    }

    axios
      .get("https://hmatechs.com/api/statistic/AllData")
      .then((response) => {
        if (response?.data) {
          setData(response?.data);
        }
      })
      .catch(() => setData({}));

  }, []);

  const apiPartners = Array.isArray(data?.Parteners) && data.Parteners.length > 0
    ? data.Parteners.map((p, i) => ({
        src: p.image,
        category: partnerLogos[i % partnerLogos.length]?.category || "government",
      }))
    : [];

  const eventsPartners = Array.isArray(eventsData?.Parteners) && eventsData.Parteners.length > 0
    ? eventsData.Parteners.map((p, i) => ({
        src: p.image,
        category: partnerLogos[i % partnerLogos.length]?.category || "government",
      }))
    : [];

  const combinedPartners = [
    ...(apiPartners.length > 0 ? apiPartners : partnerLogos),
    ...(eventsPartners.length > 0 ? eventsPartners : eventsPartnerLogos),
  ];

  const filteredPartners = activeCategory === "all"
    ? combinedPartners
    : combinedPartners.filter((p) => p.category === activeCategory);

  const config = isEmpty(data?.Configurations)
    ? {
        phone: "+97444303443",
        email: "sales@hmatechs.com",
        address: "QFC Tower, Doha, Qatar",
        addressFR: "Tour QFC, Doha, Qatar",
        addressAR: "برج QFC، الدوحة، قطر",
        openingDayStart: "Sunday",
        openingDayStartFR: "Dimanche",
        openingDayStartAR: "الأحد",
        openingDayEnd: "Thursday",
        openingDayEndFR: "Jeudi",
        openingDayEndAR: "الخميس",
        openingHourStart: "9:00 AM",
        openingHourStartFR: "9h00",
        openingHourStartAR: "9:00 صباحًا",
        openingHourEnd: "6:00 PM",
        openingHourEndFR: "18h00",
        openingHourEndAR: "6:00 مساءً",
      }
    : data.Configurations;

  return (
    <>
      <header className="header">
        <div className="container">
          <nav>
            <a href="/" onClick={navRoute("/")}>
              <div className="logo">
                <img src={Logo} alt="HMA Techs" />
              </div>
            </a>

            <input
              type="checkbox"
              id="checkbox"
              checked={menu}
              onChange={(e) => setmenu(e.target.checked)}
            />
            <label htmlFor="checkbox" id="icon" aria-label="Toggle menu">
              <svg
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d={
                    menu
                      ? "M6 6L18 18M6 18L18 6"
                      : "M4 6h16M4 12h16M4 18h16"
                  }
                ></path>
              </svg>
            </label>

            <ul onClick={(e) => e.target === e.currentTarget && setmenu(false)}>
              <li>
                <a href="/" onClick={navRoute("/")}>
                  {lang.value === "EN" ? `Home` : lang.value === "FR" ? `Accueil` : `الصفحة الرئيسية`}
                </a>
              </li>
              <li>
                <a href="/#aboutid">
                  {lang.value === "EN" ? `About` : lang.value === "FR" ? `À propos de nous` : `معلومات عنا`}
                </a>
              </li>
              <li>
                <a href="/#projectsid">
                  {lang.value === "EN" ? `Portfolio` : lang.value === "FR" ? `Portefeuille` : `المشاريع`}
                </a>
              </li>
              <li>
                <a href="/#Servicesid">
                  {lang.value === "EN" ? `Services` : lang.value === "FR" ? `Services` : `خدمات`}
                </a>
              </li>
              <li>
                <a href="#contactid" onClick={navHash("contactid")}>
                  {lang.value === "EN" ? `Contact` : lang.value === "FR" ? `Contact` : `اتصال`}
                </a>
              </li>
              <li>
                <a href="/events" onClick={navRoute("/events")}>
                  {lang.value === "EN" ? `HMA Events` : lang.value === "FR" ? `Événements HMA` : `فعاليات HMA`}
                </a>
              </li>
              <li>
                <a href="#clientsid" onClick={navHash("clientsid")}>
                  {lang.value === "EN" ? `Clients` : lang.value === "FR" ? `Clients` : `العملاء`}
                </a>
              </li>
            </ul>

            <Select
              className="selectLang"
              isSearchable={false}
              theme={(theme) => ({
                ...theme,
                borderStyle: "none",
                boxShadow: "none",
                colors: {
                  ...theme.colors,
                  neutral0: "#0d0c1c",
                  neutral30: "#0d0c1c",
                  neutral10: "#fff",
                  neutral50: "#000",
                  neutral80: "#fff",
                  primary25: "#ccc",
                  primary: "#238aec",
                  primary50: "#238aec",
                },
              })}
              styles={{
                control: (base) => ({ ...base, border: 0, boxShadow: "none" }),
                option: (base) => ({ ...base, color: "#fff" }),
              }}
              value={lang}
              onChange={(val) => {
                setlang(val);
                localStorage.setItem("lang", JSON.stringify(val));
              }}
              options={[
                { value: "EN", label: "EN" },
                { value: "FR", label: "FR" },
                { value: "AR", label: "AR" },
              ]}
            />
          </nav>
        </div>
      </header>

      {createPortal(
        <AnimatePresence>
          {menu && (
            <motion.div
              key="mobile-menu"
              className="hma-mobile-menu"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
              onClick={(e) => e.target === e.currentTarget && setmenu(false)}
            >
              <button
                type="button"
                className="hma-mobile-menu__close"
                onClick={() => setmenu(false)}
                aria-label="Close menu"
              >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
                  <path d="M6 6L18 18M6 18L18 6" strokeLinecap="round" />
                </svg>
              </button>

              <span className="hma-mobile-menu__eyebrow">
                {tr("Menu", "Menu", "القائمة")}
              </span>

              <ul className="hma-mobile-menu__list">
                {[
                  { href: "/", labels: ["Home", "Accueil", "الصفحة الرئيسية"] },
                  { href: "/#aboutid", labels: ["About", "À propos", "معلومات عنا"] },
                  { href: "/#projectsid", labels: ["Portfolio", "Portefeuille", "المشاريع"] },
                  { href: "/#Servicesid", labels: ["Services", "Services", "خدمات"] },
                  { hash: "contactid", labels: ["Contact", "Contact", "اتصال"] },
                ].map((item, i) => (
                  <motion.li
                    key={item.hash || item.href}
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 0.1 + i * 0.06, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
                  >
                    <a
                      href={item.hash ? `#${item.hash}` : item.href}
                      onClick={
                        item.hash
                          ? navHash(item.hash)
                          : item.href === "/" || item.href === "/events"
                            ? navRoute(item.href)
                            : () => setmenu(false)
                      }
                    >
                      <span className="hma-mobile-menu__num">{String(i + 1).padStart(2, "0")}</span>
                      <span className="hma-mobile-menu__label">{tr(item.labels[0], item.labels[1], item.labels[2])}</span>
                    </a>
                  </motion.li>
                ))}
              </ul>

              <motion.a
                href="/events"
                onClick={navRoute("/events")}
                className="hma-mobile-menu__cta"
                initial={{ opacity: 0, y: 16 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.4, duration: 0.5 }}
              >
                {tr("HMA Events →", "Événements HMA →", "فعاليات HMA →")}
              </motion.a>

              <motion.a
                href="#clientsid"
                onClick={navHash("clientsid")}
                className="hma-mobile-menu__cta"
                style={{ marginTop: 8 }}
                initial={{ opacity: 0, y: 16 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.5, duration: 0.5 }}
              >
                {tr("Clients →", "Clients →", "العملاء →")}
              </motion.a>

              <motion.div
                className="hma-mobile-menu__lang"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.6, duration: 0.4 }}
              >
                <span className="hma-mobile-menu__lang-label">{tr("Language", "Langue", "اللغة")}</span>
                <div className="hma-mobile-menu__lang-group" role="group">
                  {[
                    { value: "EN", label: "EN" },
                    { value: "FR", label: "FR" },
                    { value: "AR", label: "AR" },
                  ].map((opt) => (
                    <button
                      key={opt.value}
                      type="button"
                      className={`hma-mobile-menu__lang-btn ${lang.value === opt.value ? "is-active" : ""}`}
                      onClick={() => {
                        setlang(opt);
                        localStorage.setItem("lang", JSON.stringify(opt));
                      }}
                    >
                      {opt.label}
                    </button>
                  ))}
                </div>
              </motion.div>

              <span className="hma-mobile-menu__footer">
                CREATIVITY · INNOVATION · FUTURE
              </span>
            </motion.div>
          )}
        </AnimatePresence>,
        document.body
      )}

      {/* Hero */}
      <section
        id="clientsid"
        style={{
          minHeight: "100vh",
          background: "#0d0c1c",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          overflow: "hidden",
          padding: "140px 0 80px",
        }}
      >
        {/* Animated gradient orbs */}
        <motion.div
          animate={{ scale: [1, 1.2, 1], rotate: [0, 45, 0] }}
          transition={{ duration: 12, repeat: Infinity, ease: "linear" }}
          style={{
            position: "absolute",
            width: 700,
            height: 700,
            borderRadius: "50%",
            background: "radial-gradient(circle, rgba(201,161,74,0.12) 0%, transparent 70%)",
            top: "-20%",
            right: "-10%",
            pointerEvents: "none",
          }}
        />
        <motion.div
          animate={{ scale: [1.2, 1, 1.2], rotate: [0, -30, 0] }}
          transition={{ duration: 15, repeat: Infinity, ease: "linear" }}
          style={{
            position: "absolute",
            width: 500,
            height: 500,
            borderRadius: "50%",
            background: "radial-gradient(circle, rgba(100,130,255,0.06) 0%, transparent 70%)",
            bottom: "-10%",
            left: "-5%",
            pointerEvents: "none",
          }}
        />

        {/* Decorative grid pattern */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            backgroundImage: "radial-gradient(rgba(255,255,255,0.03) 1px, transparent 1px)",
            backgroundSize: "40px 40px",
            pointerEvents: "none",
          }}
        />

        {/* Floating elements */}
        {[
          { top: "15%", left: "8%", delay: 0 },
          { top: "25%", right: "12%", delay: 1.5 },
          { bottom: "20%", left: "15%", delay: 3 },
          { bottom: "30%", right: "8%", delay: 4.5 },
        ].map((pos, i) => (
          <motion.div
            key={i}
            animate={{ y: [0, -20, 0], opacity: [0.15, 0.3, 0.15] }}
            transition={{ duration: 5 + i, repeat: Infinity, delay: pos.delay, ease: "easeInOut" }}
            style={{
              position: "absolute",
              ...pos,
              width: 6 + i * 2,
              height: 6 + i * 2,
              borderRadius: "50%",
              background: "#c9a14a",
              opacity: 0.15,
              pointerEvents: "none",
            }}
          />
        ))}

        {/* Gold seal watermark */}
        <motion.div
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1.5, ease: [0.22, 1, 0.36, 1] }}
          style={{
            position: "absolute",
            right: "5%",
            top: "12%",
            width: 120,
            height: 120,
            borderRadius: "50%",
            border: "2px solid rgba(201,161,74,0.15)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            pointerEvents: "none",
          }}
        >
          <motion.div
            animate={{ rotate: 360 }}
            transition={{ duration: 40, repeat: Infinity, ease: "linear" }}
            style={{
              width: 100,
              height: 100,
              borderRadius: "50%",
              border: "1px solid rgba(201,161,74,0.1)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 10,
              color: "rgba(201,161,74,0.2)",
              fontWeight: 700,
              letterSpacing: 2,
              textTransform: "uppercase",
            }}
          >
            <span style={{ transform: "rotate(180deg)", textAlign: "center", lineHeight: 1.3 }}>
              EXCELLENCE
              <br />
              SINCE 2009
            </span>
          </motion.div>
        </motion.div>

        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          <div className="row align-items-center">
            <div className="col-lg-7">
              <motion.span
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 10,
                  padding: "8px 20px",
                  borderRadius: 999,
                  border: "1px solid rgba(201,161,74,0.3)",
                  background: "rgba(201,161,74,0.08)",
                  color: "#c9a14a",
                  fontSize: 13,
                  fontWeight: 700,
                  letterSpacing: "2px",
                  textTransform: "uppercase",
                  marginBottom: 30,
                }}
              >
                <span style={{
                  width: 8, height: 8, borderRadius: "50%",
                  background: "#c9a14a", boxShadow: "0 0 15px rgba(201,161,74,0.3)",
                }} />
                {tr("Trusted By Leaders", "Reconnu par les leaders", "موثوق من القادة")}
              </motion.span>

              <motion.h1
                initial={{ opacity: 0, y: 40 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.4, ease: [0.22, 1, 0.36, 1] }}
                style={{
                  fontSize: window.innerWidth < 768 ? "38px" : "64px",
                  fontWeight: 900,
                  color: "#fff",
                  lineHeight: 1.1,
                  marginBottom: 24,
                }}
              >
                {tr("Our Clients", "Nos Clients", "عملاؤنا")}
              </motion.h1>

              <motion.p
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7, delay: 0.6 }}
                style={{
                  fontSize: 17,
                  color: "rgba(255,255,255,0.55)",
                  maxWidth: 580,
                  lineHeight: 1.8,
                  marginBottom: 40,
                }}
              >
                {tr(
                  "Government and enterprise organizations across Qatar trust us to deliver reliable IT solutions and services. Our clients across the public and private sectors rely on our digital solutions to improve performance and deliver consistent results.",
                  "Les organismes gouvernementaux et les entreprises du Qatar nous font confiance pour fournir des solutions et services IT fiables. Nos clients des secteurs public et privé comptent sur nos solutions numériques pour améliorer leurs performances et obtenir des résultats constants.",
                  "تثق بنا المؤسسات الحكومية والخاصة في قطر لتقديم حلول وخدمات تقنية موثوقة. يعتمد عملاؤنا في القطاعين العام والخاص على حلولنا الرقمية لتحسين الأداء وتحقيق نتائج متسقة."
                )}
              </motion.p>

              {/* Stats row */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7, delay: 0.9 }}
                style={{ display: "flex", gap: 40, flexWrap: "wrap" }}
              >
                {[
                  { icon: <Award size={20} />, value: "17+", label: tr("Years Experience", "Ans d'expérience", "سنوات خبرة") },
                  { icon: <Users size={20} />, value: "1200+", label: tr("Happy Clients", "Clients satisfaits", "عملاء سعداء") },
                  { icon: <Briefcase size={20} />, value: "3500+", label: tr("Projects Delivered", "Projets livrés", "مشروع منجز") },
                ].map((stat, i) => (
                  <div key={i} style={{ display: "flex", alignItems: "center", gap: 12 }}>
                    <div style={{
                      width: 44, height: 44, borderRadius: 12,
                      background: "rgba(201,161,74,0.1)",
                      display: "flex", alignItems: "center", justifyContent: "center",
                      color: "#c9a14a",
                    }}>
                      {stat.icon}
                    </div>
                    <div>
                      <div style={{ fontSize: 24, fontWeight: 900, color: "#fff", lineHeight: 1.2 }}>{stat.value}</div>
                      <div style={{ fontSize: 12, color: "rgba(255,255,255,0.4)", fontWeight: 500 }}>{stat.label}</div>
                    </div>
                  </div>
                ))}
              </motion.div>
            </div>

            <div className="col-lg-5 d-none d-lg-block">
              <motion.div
                initial={{ opacity: 0, x: 40 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.8, ease: [0.22, 1, 0.36, 1] }}
                style={{
                  position: "relative",
                  width: "100%",
                  height: 400,
                }}
              >
                {/* Logo cluster */}
                {partnerLogos.slice(0, 8).map((p, i) => {
                  const angle = (i / 8) * Math.PI * 2;
                  const radius = 140 + (i % 3) * 20;
                  return (
                    <motion.div
                      key={i}
                      animate={{ y: [0, -6, 0] }}
                      transition={{ duration: 3 + i * 0.3, repeat: Infinity, ease: "easeInOut", delay: i * 0.2 }}
                      style={{
                        position: "absolute",
                        left: `calc(50% + ${Math.cos(angle) * radius}px - 40px)`,
                        top: `calc(50% + ${Math.sin(angle) * radius}px - 30px)`,
                        width: 80,
                        height: 60,
                        borderRadius: 12,
                        background: "rgba(255,255,255,0.04)",
                        border: "1px solid rgba(255,255,255,0.06)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: 8,
                      }}
                    >
                      <img src={p.src} alt="" style={{ maxWidth: "80%", maxHeight: "80%", objectFit: "contain", opacity: 0.6 }} />
                    </motion.div>
                  );
                })}

                {/* Center glow */}
                <div style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: 100,
                  height: 100,
                  borderRadius: "50%",
                  background: "radial-gradient(circle, rgba(201,161,74,0.15), transparent)",
                }} />
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      {/* Clients Grid */}
      <section
        style={{
          background: "#f8f7f4",
          padding: "100px 0",
          position: "relative",
        }}
      >
        <div className="container">
          <Reveal as="div" y={30} duration={1.0}>
            <div style={{ textAlign: "center", marginBottom: 60 }}>
              <span
                style={{
                  padding: "10px 22px",
                  borderRadius: 999,
                  border: "1px solid rgba(201,161,74,0.3)",
                  background: "rgba(201,161,74,0.08)",
                  color: "#b8942e",
                  fontSize: 13,
                  fontWeight: 700,
                  letterSpacing: "2px",
                  textTransform: "uppercase",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 10,
                }}
              >
                <span style={{
                  width: 8, height: 8, borderRadius: "50%",
                  background: "#b8942e", boxShadow: "0 0 15px rgba(184,148,46,0.3)",
                }} />
                {tr("Our Partners", "Nos Partenaires", "شركاؤنا")}
              </span>

              <h2
                style={{
                  fontSize: window.innerWidth < 768 ? "28px" : "42px",
                  fontWeight: 900,
                  color: "#1a1a1a",
                  marginTop: 25,
                }}
              >
                {tr(
                  "Trusted by industry leaders across Qatar",
                  "Approuvé par les leaders de l'industrie au Qatar",
                  "موثوق من قادة الصناعة في قطر"
                )}
              </h2>
            </div>
          </Reveal>

          {/* Category Filter */}
          <Reveal as="div" y={20} duration={0.8}>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                gap: 10,
                marginBottom: 60,
              }}
            >
              <button
                onClick={() => setActiveCategory("all")}
                style={{
                  padding: "10px 22px",
                  borderRadius: 999,
                  border: "none",
                  cursor: "pointer",
                  fontSize: 13,
                  fontWeight: 600,
                  background: activeCategory === "all" ? "#c9a14a" : "#fff",
                  color: activeCategory === "all" ? "#fff" : "#333",
                  boxShadow: activeCategory === "all"
                    ? "0 4px 20px rgba(201,161,74,0.3)"
                    : "0 2px 10px rgba(0,0,0,0.05)",
                  transition: "all 0.3s ease",
                }}
              >
                {tr("All", "Tous", "الكل")}
              </button>
              {clientCategories.map((cat) => (
                <button
                  key={cat.id}
                  onClick={() => setActiveCategory(cat.id)}
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 6,
                    padding: "10px 20px",
                    borderRadius: 999,
                    border: "none",
                    cursor: "pointer",
                    fontSize: 13,
                    fontWeight: 600,
                    background: activeCategory === cat.id ? "#c9a14a" : "#fff",
                    color: activeCategory === cat.id ? "#fff" : "#333",
                    boxShadow: activeCategory === cat.id
                      ? "0 4px 20px rgba(201,161,74,0.3)"
                      : "0 2px 10px rgba(0,0,0,0.05)",
                    transition: "all 0.3s ease",
                  }}
                >
                  {cat.icon}
                  {tr(cat.label, cat.labelFR, cat.labelAR)}
                </button>
              ))}
            </div>
          </Reveal>

          {/* Partner Logos Grid */}
          <motion.div layout className="row">
            {filteredPartners.length > 0 ? (
              filteredPartners.map((item, i) => (
                <motion.div
                  key={i}
                  layout
                  initial={{ opacity: 0, scale: 0.9 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 0.9 }}
                  transition={{ duration: 0.35, delay: i * 0.04 }}
                  className="col-lg-3 col-md-4 col-sm-6 col-6"
                  style={{ marginBottom: 30 }}
                >
                  <motion.div
                    whileHover={{ y: -8, boxShadow: "0 20px 60px rgba(0,0,0,0.1)" }}
                    style={{
                      background: "#fff",
                      borderRadius: 20,
                      padding: "30px 20px",
                      height: "160px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0 4px 20px rgba(0,0,0,0.04)",
                      border: "1px solid rgba(0,0,0,0.04)",
                      cursor: "pointer",
                    }}
                  >
                    <motion.img
                      src={item.src}
                      alt={`Partner ${i + 1}`}
                      whileHover={{ scale: 1.1 }}
                      style={{
                        maxWidth: "85%",
                        maxHeight: "85%",
                        objectFit: "contain",
                      }}
                    />
                  </motion.div>
                </motion.div>
              ))
            ) : (
              <div className="col-12 text-center" style={{ padding: 60 }}>
                <p style={{ color: "#999", fontSize: 16 }}>
                  {tr(
                    "No clients found in this category.",
                    "Aucun client trouvé dans cette catégorie.",
                    "لم يتم العثور على عملاء في هذه الفئة."
                  )}
                </p>
              </div>
            )}
          </motion.div>
        </div>
      </section>

      {/* CTA Section */}
      <section
        style={{
          background: "linear-gradient(135deg, #0d0c1c 0%, #1a1a2e 100%)",
          padding: "100px 0",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1.2 }}
          style={{
            position: "absolute",
            width: 500,
            height: 500,
            borderRadius: "50%",
            background: "rgba(201,161,74,0.08)",
            filter: "blur(100px)",
            top: "-100px",
            left: "-100px",
          }}
        />

        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          <div className="row">
            <div className="col-lg-8 mx-auto text-center">
              <Reveal y={30} duration={1.0}>
                <h2
                  style={{
                    fontSize: window.innerWidth < 768 ? "32px" : "48px",
                    fontWeight: 900,
                    color: "#fff",
                    marginBottom: 20,
                  }}
                >
                  {tr(
                    "Ready to Go Digital? We're Here to Lead.",
                    "Prêt pour le digital ? Nous sommes là pour vous guider.",
                    "مستعد للتحول الرقمي؟ نحن هنا لقيادتك."
                  )}
                </h2>
                <p
                  style={{
                    color: "rgba(255,255,255,0.6)",
                    fontSize: 18,
                    marginBottom: 40,
                    maxWidth: 600,
                    margin: "0 auto 40px",
                  }}
                >
                  {tr(
                    "Partner with HMA Techs and transform your business with cutting-edge technology solutions.",
                    "Partenariat avec HMA Techs pour transformer votre entreprise avec des solutions technologiques de pointe.",
                    "تعاون مع HMA Techs وحوّل أعمالك بحلول تقنية متطورة."
                  )}
                </p>
                <MagneticCTA>
                  <a
                    href="#contactid"
                    onClick={navHash("contactid")}
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 12,
                      padding: "16px 40px",
                      borderRadius: 999,
                      background: "linear-gradient(135deg, #c9a14a, #b8942e)",
                      color: "#fff",
                      fontWeight: 700,
                      fontSize: 16,
                      textDecoration: "none",
                      boxShadow: "0 8px 30px rgba(201,161,74,0.3)",
                      transition: "all 0.3s ease",
                      border: "none",
                      cursor: "pointer",
                    }}
                  >
                    {tr("Contact Us", "Contactez-nous", "اتصل بنا")}
                    <ArrowUpRight size={20} />
                  </a>
                </MagneticCTA>
              </Reveal>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section
        id="contactid"
        style={{
          background: "#fff",
          padding: window.innerWidth < 768 ? "60px 0" : "100px 0",
          position: "relative",
        }}
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <Reveal y={30} duration={1.0}>
                <div style={{ marginBottom: 40 }}>
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 10,
                      padding: "8px 20px",
                      borderRadius: 999,
                      border: "1px solid rgba(201,161,74,0.3)",
                      background: "rgba(201,161,74,0.08)",
                      color: "#c9a14a",
                      fontSize: 13,
                      fontWeight: 700,
                      letterSpacing: "2px",
                      textTransform: "uppercase",
                      marginBottom: 20,
                    }}
                  >
                    <span style={{
                      width: 8, height: 8, borderRadius: "50%",
                      background: "#c9a14a", boxShadow: "0 0 15px rgba(201,161,74,0.3)",
                    }} />
                    {tr("Get In Touch", "Entrer en contact", "تواصل معنا")}
                  </span>
                  <h3
                    style={{
                      fontSize: window.innerWidth < 768 ? 28 : 38,
                      fontWeight: 900,
                      color: "#0d0c1c",
                      margin: "20px 0 16px",
                      lineHeight: 1.2,
                    }}
                  >
                    {tr(
                      "Let's discuss your next project",
                      "Discutons de votre prochain projet",
                      "دعنا نناقش مشروعك القادم"
                    )}
                  </h3>
                  <p style={{ color: "rgba(0,0,0,0.5)", fontSize: 16, lineHeight: 1.7, margin: 0 }}>
                    {tr(
                      "Whether you need a full IT infrastructure overhaul or a niche technical solution, our team is ready to help.",
                      "Que vous ayez besoin d'une refonte complète de votre infrastructure IT ou d'une solution technique de niche, notre équipe est prête à vous aider.",
                      "سواء كنت بحاجة إلى إصلاح شامل للبنية التحتية لتقنية المعلومات أو حل تقني متخصص، فإن فريقنا مستعد للمساعدة."
                    )}
                  </p>
                </div>

                <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
                  {[
                    { icon: "fa-sharp fa-solid fa-phone", label: tr("Phone", "Téléphone", "الهاتف"), value: config?.phone, href: `tel:${config?.phone}` },
                    { icon: "fa-regular fa-envelope", label: tr("Email", "Email", "البريد الإلكتروني"), value: config?.email, href: `mailto:${config?.email}` },
                    { icon: "fa-sharp fa-solid fa-location-dot", label: tr("Address", "Adresse", "العنوان"), value: tr(config?.address, config?.addressFR, config?.addressAR) },
                  ].map((item, i) => (
                    <motion.div
                      key={i}
                      initial={{ opacity: 0, x: -40, scale: 0.9 }}
                      whileInView={{ opacity: 1, x: 0, scale: 1 }}
                      viewport={{ once: true, margin: "-40px" }}
                      transition={{
                        duration: 0.7,
                        delay: i * 0.2,
                        ease: [0.22, 1, 0.36, 1],
                      }}
                      whileHover={{ x: 8, transition: { duration: 0.3 } }}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 16,
                        padding: "16px 20px",
                        borderRadius: 16,
                        cursor: "default",
                        transition: "background 0.3s ease",
                      }}
                      onMouseEnter={(e) => e.currentTarget.style.background = "rgba(201,161,74,0.06)"}
                      onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}
                    >
                      <motion.div
                        initial={{ rotate: -180, scale: 0 }}
                        whileInView={{ rotate: 0, scale: 1 }}
                        viewport={{ once: true, margin: "-40px" }}
                        transition={{ duration: 0.6, delay: i * 0.2 + 0.2, ease: [0.22, 1, 0.36, 1] }}
                        whileHover={{ rotate: 15, scale: 1.15 }}
                        style={{
                          width: 48, height: 48, borderRadius: 14,
                          background: "rgba(201,161,74,0.12)",
                          display: "flex", alignItems: "center", justifyContent: "center",
                          flexShrink: 0,
                          boxShadow: "0 4px 15px rgba(201,161,74,0.15)",
                        }}
                      >
                        <i className={item.icon} style={{ color: "#c9a14a", fontSize: 20 }} />
                      </motion.div>
                      <div>
                        <div style={{ color: "rgba(0,0,0,0.45)", fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: 1.5 }}>{item.label}</div>
                        <div style={{ color: "#0d0c1c", fontSize: 16, fontWeight: 600, marginTop: 3 }}>
                          {item.href ? <a href={item.href} style={{ color: "#0d0c1c", textDecoration: "none" }}>{item.value}</a> : item.value}
                        </div>
                      </div>
                    </motion.div>
                  ))}
                </div>
              </Reveal>
            </div>
            <div className="col-lg-6">
              <Reveal y={30} duration={1.0}>
                <form
                  onSubmit={(e) => e.preventDefault()}
                  style={{
                    background: "#f8f8f8",
                    borderRadius: 24,
                    padding: window.innerWidth < 768 ? 20 : 40,
                    border: "1px solid rgba(0,0,0,0.06)",
                    boxSizing: "border-box",
                  }}
                >
                  <div className="input-group" style={{ display: "flex", flexDirection: window.innerWidth < 768 ? "column" : "row", gap: 16, marginBottom: 20 }}>
                    <div className="single-input" style={{ flex: 1 }}>
                      <input
                        type="text"
                        placeholder={tr("Your Name", "Votre nom", "اسمك")}
                        style={{
                          width: "100%",
                          padding: "14px 18px",
                          borderRadius: 12,
                          border: "1px solid rgba(0,0,0,0.1)",
                          background: "#fff",
                          color: "#0d0c1c",
                          fontSize: 15,
                          outline: "none",
                          boxSizing: "border-box",
                        }}
                      />
                    </div>
                    <div className="single-input" style={{ flex: 1 }}>
                      <input
                        type="email"
                        placeholder={tr("Your Email", "Votre email", "بريدك الإلكتروني")}
                        style={{
                          width: "100%",
                          padding: "14px 18px",
                          borderRadius: 12,
                          border: "1px solid rgba(0,0,0,0.1)",
                          background: "#fff",
                          color: "#0d0c1c",
                          fontSize: 15,
                          outline: "none",
                          boxSizing: "border-box",
                        }}
                      />
                    </div>
                  </div>
                  <div className="single-input" style={{ marginBottom: 20 }}>
                    <input
                      type="text"
                      placeholder={tr("Subject", "Sujet", "الموضوع")}
                      style={{
                        width: "100%",
                        padding: "14px 18px",
                        borderRadius: 12,
                        border: "1px solid rgba(0,0,0,0.1)",
                        background: "#fff",
                        color: "#0d0c1c",
                        fontSize: 15,
                        outline: "none",
                        boxSizing: "border-box",
                      }}
                    />
                  </div>
                  <div className="textarea" style={{ marginBottom: 24 }}>
                    <textarea
                      placeholder={tr("Your Message", "Votre message", "رسالتك")}
                      rows={5}
                      style={{
                        width: "100%",
                        padding: "14px 18px",
                        borderRadius: 12,
                        border: "1px solid rgba(0,0,0,0.1)",
                        background: "#fff",
                        color: "#0d0c1c",
                        fontSize: 15,
                        outline: "none",
                        resize: "vertical",
                        boxSizing: "border-box",
                      }}
                    />
                  </div>
                  <button
                    type="submit"
                    style={{
                      padding: "14px 40px",
                      borderRadius: 999,
                      border: "none",
                      background: "linear-gradient(135deg, #c9a14a, #b8942e)",
                      color: "#fff",
                      fontWeight: 700,
                      fontSize: 15,
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                      boxShadow: "0 8px 30px rgba(201,161,74,0.3)",
                    }}
                  >
                    {tr("Send Message", "Envoyer le message", "إرسال الرسالة")}
                    <i className="fa-sharp fa-light fa-arrow-right-long" style={{ marginLeft: 10 }} />
                  </button>
                </form>
              </Reveal>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer pt-100 pb-70" style={{ background: "#0d0c1c" }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="footer__widget">
                <h5>{lang.value === "EN" ? `Contact Us` : lang.value === "FR" ? `Contactez-nous` : `اتصل بنا`}</h5>
                <div className="footer__widget--contact">
                  <ul>
                    <li><i className="fa-sharp fa-solid fa-phone" /><a href={`tel:${config?.phone}`}>{config?.phone}</a></li>
                    <li><i className="fa-regular fa-envelope" /><a href={`mailto:${config?.email}`}>{config?.email}</a></li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-2 col-md-6 col-sm-6">
              <div className="footer__widget">
                <h5>{lang.value === "EN" ? `Links` : lang.value === "FR" ? `Links` : `روابط`}</h5>
                <div className="footer__widget--link">
                  <ul>
                    <li><a href="/">{tr("Home", "Accueil", "الصفحة الرئيسية")}</a></li>
                    <li><a href="/events">{tr("HMA Events", "Événements HMA", "فعاليات HMA")}</a></li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-5 col-md-6 col-sm-6">
              <div className="footer__widget">
                <h5>{lang.value === "EN" ? `Newsletter` : lang.value === "FR" ? `Bulletin` : `نشرة`}</h5>
                <div className="footer__widget--newsletter">
                  <p>
                    {lang.value === "EN"
                      ? `Stay up to date with the latest technology trends and insights from HMA Techs.`
                      : lang.value === "FR"
                      ? `Restez informé des dernières tendances technologiques et des informations de HMA Techs.`
                      : `ابق على اطلاع بأحدث اتجاهات التكنولوجيا والرؤى من HMA Techs.`}
                  </p>
                  <form action="#" className="newsletter-box">
                    <input type="email" placeholder={tr("Email Address", "Adresse email", "البريد الإلكتروني")} />
                    <button type="submit">
                      {lang.value === "EN" ? `Submit` : lang.value === "FR" ? `Soumettre` : `إرسال`}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>

      <div className="footer-credit">
        <div className="container">
          <div className="footer-credit--img">
            <a onClick={() => navigate("/")}><img src={Logo} alt="footer logo" /></a>
          </div>
          <div className="footer-credit__wrapper mt-25">
            <div className="copy-right">
              {lang.value === "EN" ? `Copyright` : lang.value === "FR" ? `Copyright` : `حقوق الطبع والنشر`}
              &copy; {new Date().getFullYear()} - <a href="/"> HMA Techs &nbsp;</a>
              &nbsp;
              {lang.value === "EN" ? `All Rights Reserved` : lang.value === "FR" ? `Tous droits réservés ` : ` جميع الحقوق محفوظة`}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Clients;
